export function getSelectedOwnerIds(
  ownerSelections: Record<string, boolean>
): string[] {
  const ids = Object.keys(ownerSelections);
  return ids.filter((key) => {
    return ownerSelections[key] !== undefined && ownerSelections[key];
  });
}
